/* BOX IMPORT: traduce al español los textos que Shopify genera en inglés mientras el idioma principal de la tienda sea inglés
   (botón de compra rápida y filtros del catálogo). Archivo: assets/box-import-es.js */
(() => {
  const D = {
    'Buy it now': 'Comprar ahora',
    'Availability': 'Disponibilidad',
    'Price': 'Precio',
    'In stock': 'En stock',
    'Out of stock': 'Sin stock',
    'Filter': 'Filtrar',
    'Filter and sort': 'Filtrar y ordenar',
    'Sort by': 'Ordenar por',
    'Clear': 'Borrar',
    'Clear all': 'Borrar todo',
    'Apply': 'Aplicar',
    'From': 'Desde',
    'To': 'Hasta',
    'Remove all': 'Quitar todo',
  };
  const ZONAS = '.shopify-payment-button, [class*="facets"], [class*="filter"], [class*="sorting"]';
  const traducir = (raiz) => {
    raiz.querySelectorAll?.(ZONAS).forEach((zona) => {
      const w = document.createTreeWalker(zona, NodeFilter.SHOW_TEXT);
      let n;
      while ((n = w.nextNode())) {
        const t = n.nodeValue.trim();
        if (D[t]) n.nodeValue = n.nodeValue.replace(t, D[t]);
      }
    });
  };
  const iniciar = () => {
    traducir(document);
    new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((x) => x.nodeType === 1 && traducir(x.parentElement || x)))).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
